import React from 'react';
// import DistImg from '../../assets/images/dist.png';
import { FaSearchPlus } from 'react-icons/fa';
import Branch from '../../models/branch.model';
import translates from '../../translation.json';
import { lang } from '../../config/app.config';

interface Props {
  branch: Branch
}

const Maps: React.FC<Props> = ({ branch }) => {
  return (
    <div className="map-wrapper">
      <figure>
        {branch.image ?
          <img src={branch.image} alt="" />
          : ""}
        <figcaption>
          {branch.district ? branch.district : branch.province}
          {branch?.file ?
            <a href={branch?.file} className='branch-profile' target='_blank'>
              <span>
                {translates.translation[lang].branch_profile}
              </span>
            </a>
            : <></>}
        </figcaption>
        <a href={branch.image} className="map-icon">
          <FaSearchPlus />
        </a>
      </figure>
    </div>
  )
}


export default Maps;